import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLargeXIcon2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={23} fill="none" {...props}>
    <path stroke="#D04237" d="m1.354.86 21.213 21.213M.646 21.86 21.86.646" />
  </svg>
);
export default SvgLargeXIcon2;
